module.exports = __webpack_public_path__ + "img/展示.d669d9a6.png";